import { PublicLayout } from "@/components/PublicLayout";
import { CondoForm } from "@/components/LeadForms";
import { useSeo } from "@/lib/useSeo";
import { CheckCircle2 } from "lucide-react";

export default function PreventivoCondominio() {
  useSeo({
    title: "Preventivo Amministrazione Condominio Scandicci e Firenze | Edilstudio",
    description: "Richiedi un preventivo gratuito per l'amministrazione del tuo condominio a Scandicci o Firenze. Gestione trasparente, reperibilità h24 e portale condòmini digitale.",
    canonicalPath: "/preventivo-condominio",
  });
  return (
    <PublicLayout>
      <section className="grid lg:grid-cols-2">
        <div className="bg-[#1B2A41] text-white px-6 sm:px-10 lg:px-16 py-16 lg:py-24">
          <p className="eyebrow text-[#F5A623]">Per consiglieri e condòmini</p>
          <h1 className="font-display text-4xl lg:text-5xl font-bold mt-3 leading-tight">Preventivo amministrazione condominio</h1>
          <p className="text-white/80 mt-5 leading-relaxed max-w-md">Gestione contabile impeccabile, reperibilità per urgenze e guasti, portale digitale per ogni condomino e sopralluoghi periodici. Preventivo chiaro e senza sorprese.</p>
          <ul className="mt-8 space-y-4">
            {["Preventivo gratuito e trasparente", "Reperibilità h24 per le urgenze", "Portale digitale per ogni condomino", "Assemblee anche in modalità telematica"].map((t) => (
              <li key={t} className="flex items-start gap-3"><CheckCircle2 className="w-5 h-5 text-[#F5A623] mt-0.5 shrink-0" /><span className="text-white/85">{t}</span></li>
            ))}
          </ul>
        </div>
        <div className="px-6 sm:px-10 lg:px-16 py-16 lg:py-24 bg-[#F7FAFC]">
          <div className="bg-white rounded-2xl border border-[#DCE6EF] p-6 sm:p-8">
            <h2 className="font-display text-2xl font-bold text-[#1B2A41]">Richiedi il preventivo</h2>
            <p className="text-sm text-[#566476] mt-1 mb-6">Raccontaci del tuo condominio: ti prepariamo un'offerta su misura.</p>
            <CondoForm />
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
